import { render, staticRenderFns } from "./VideoEvidence.vue?vue&type=template&id=688dfa3e&"
import script from "./VideoEvidence.vue?vue&type=script&lang=js&"
export * from "./VideoEvidence.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports